import { render } from "./header-top-menu.vue?vue&type=template&id=af8fcb4a&scoped=true&ts=true"
import script from "./header-top-menu.vue?vue&type=script&lang=ts"
export * from "./header-top-menu.vue?vue&type=script&lang=ts"

import "./header-top-menu.vue?vue&type=style&index=0&id=af8fcb4a&lang=scss&scoped=true"

import exportComponent from "/data/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-af8fcb4a"]])

export default __exports__